import React, { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { supabase } from "../supabase/client";
import { useLogin } from "../context/LoginContext";
import {
  IconBell,
  // IconDataBase,
  // IconDocument,
  IconDollar,
  IconEarth,
  // IconFileClip,
  // IconGear,
  // IconPdf,
  IconSignOut,
  IconUser,
} from "./icons/Icons";
// import MenuItem from "./common/MenuItem";

const Navbar = () => {
  const [isAvatarOpen, setIsAvatarOpen] = useState(false);
  const [isDollarOpen, setIsDollarOpen] = useState(false);
  const [dataUser, setDataUser] = useState([]);

  const { user } = useLogin();

  useEffect(() => {
    if (user)
      getDataUser(user?.id);
  }, [user]);

  const getDataUser = async (id) => {
    const { data, error } = await supabase
      .from("users")
      .select("first_name, last_name, avatar")
      .eq("id", id)
      .single();
    if (error) {
      console.log("error", error);
      return;
    }
    setDataUser(data);
  };

  const toggleAvatar = () => {
    setIsAvatarOpen(!isAvatarOpen);
    setIsDollarOpen(false);
  };

  const toggleDollar = () => {
    setIsDollarOpen(!isDollarOpen);
    setIsAvatarOpen(false);
  };

  return (
    <>
      <nav
        className={`w-full transition-all duration-300 bg-white z-50 border-b border-gray-300`}
      >
        <div
          className={`container mx-auto flex items-center justify-between px-4 py-2 transition-all duration-300`}
        >
          <div className="flex items-center">
            <Link to="/">
              <img
                className="w-40"
                src="https://www.arbitrajeccia.com.pe/assets/logo_arbitraje.png"
                alt="Centro de arbitraje CCIA"
              />
            </Link>
          </div>
          <div className="flex items-center space-x-4">
            <a href="https" className="text-black hover:text-[#6571ff]">
              <IconEarth className="w-6" />
            </a>
            <button
              className="text-black hover:text-[#6571ff] relative"
              onClick={toggleDollar}
            >
              <IconDollar className="w-6" />
              {isDollarOpen && (
                <div className="absolute -right-7 top-14 left-auto w-max bg-white rounded-sm shadow-lg py-2 z-50">
                  <div className="flex flex-col items-center w-full px-12 py-4">
                    <h3 className="text-left text-black text-[.95rem] font-medium">
                      Compra:{" "}
                      <small className="text-gray-400">2023-23-12</small>
                    </h3>
                    <p className="text-left text-gray-400 text-xs">
                      <span className="text-black font-medium">S/.</span> 0.00
                    </p>
                  </div>
                  <div className="flex flex-col items-center w-full px-12 py-4">
                    <h3 className="text-left text-black text-[.95rem] font-medium">
                      Venta: <small className="text-gray-400">2023-23-12</small>
                    </h3>
                    <p className="text-left text-gray-400 text-xs">
                      <span className="text-black font-medium">S/.</span> 0.00
                    </p>
                  </div>
                </div>
              )}
            </button>
            <a
              href="https"
              className="text-black hover:text-[#6571ff] font-medium flex items-center gap-1"
            >
              <IconBell className="w-6" />
              Ingreso de escritos
            </a>
            <a
              href="https"
              className="text-black hover:text-[#6571ff] font-medium flex items-center gap-1"
            >
              <IconBell className="w-6" />
              Ingreso de peticiones
            </a>
            <button
              className="text-white hover:text-[#6571ff] focus:outline-none relative"
              onClick={toggleAvatar}
            >
              <img
                src={`/images/${dataUser?.avatar}.avif`}
                alt="Avatar"
                className="w-10 h-10 rounded-full md:inline-block"
              />
              {isAvatarOpen && (
                <div className="absolute -right-7 top-14 left-auto w-max bg-white rounded-sm shadow-lg py-2 z-50">
                  <div className="flex flex-col items-center w-full px-12 py-4">
                    <img
                      src={`/images/${dataUser?.avatar}.avif`}
                      alt="Avatar"
                      className="w-[80px] h-[80px] rounded-full mb-4"
                    />
                    <h3 className="text-center text-black text-[.95rem] font-medium">
                      {dataUser?.first_name} {dataUser?.last_name}
                    </h3>
                    <p className="text-center text-gray-400 text-xs">
                      {user.email}
                    </p>
                  </div>
                  <div className="border-t border-gray-200 py-2">
                    <a
                      href="."
                      className="flex items-end text-left gap-[6px] px-4 py-2 text-gray-600 hover:bg-gray-100 pointer-events-none"
                    >
                      <IconUser className="w-[16px]" />
                      <span className="leading-none text-[.812rem]">
                        Mi perfil
                      </span>
                    </a>
                    <a
                      href="#!"
                      className="flex items-end text-left gap-[6px] px-4 py-2 text-gray-600 hover:bg-gray-100"
                    >
                      <IconSignOut className="w-[16px]" />
                      <span
                        className="leading-none text-[.812rem]"
                        onClick={() => supabase.auth.signOut()}
                      >
                        Cerrar Sesión
                      </span>
                    </a>
                  </div>
                </div>
              )}
            </button>
          </div>
        </div>
      </nav>
      {/* <nav
        className={`w-full transition-all duration-300 bg-white sticky top-0 z-[100] shadow-nav`}
      >
        <div className="container mx-auto">
          <ul className="flex items-center justify-center gap-8">
            <MenuItem
              label={"Procesos arbitrales"}
              subitems={[
                { label: "Procesos arbitrales", url: "/procesos" },
                { label: "Expediente digital", url: "/expediente" },
                { label: "Dashboard", url: "/dashboard" },
              ]}
              icon={<IconFileClip className="w-[18px]" />}
            />
            <MenuItem
              label={"Trámite documentario"}
              subitems={[
                { label: "Escritos", url: "/escritos" },
                { label: "Audiencias", url: "/audiencias" },
                { label: "Cartas", url: "/cartas" },
                { label: "Resoluciones", url: "/resoluciones" },
                { label: "Notificaciones", url: "/notificaciones" },
              ]}
              icon={<IconDocument className="w-[18px]" />}
            />
            <MenuItem
              label={"Árbitros"}
              subitems={[
                { label: "Gestión de árbitros", url: "/arbitros" },
                { label: "Sorteo tribunal arbitral", url: "/sorteo" },
              ]}
              icon={<IconUser className="w-[20px]" />}
            />
            <MenuItem
              label={"Reportes"}
              subitems={[
                { label: "Listado de árbitros", url: "/reportes" },
                { label: "Procesos por año", url: "/procesos_anio" },
              ]}
              icon={<IconPdf className="w-[18px]" />}
            />
            <MenuItem
              label={"Maestros"}
              subitems={[
                { label: "Especialidades", url: "/especialidades" },
                { label: "Personas", url: "/personas" },
                { label: "Modalidades proceso", url: "/modalidades" },
                { label: "Opciones modalidades", url: "/opciones_modalidad" },
                { label: "Estados proceso", url: "/estado_proceso" },
                { label: "Opciones estado", url: "/opciones_estado" },
              ]}
              icon={<IconDataBase className="w-[18px]" />}
            />
            <MenuItem
              label={"Configuración"}
              subitems={[
                { label: "Usuarios", url: "/usuarios" },
                { label: "Permisos sistema", url: "/permisos" },
              ]}
              icon={<IconGear className="w-[16px]" />}
            />
          </ul>
        </div>
      </nav> */}
      <div className="container mx-auto pb-8">
        <Outlet />
      </div>
    </>
  );
};

export default Navbar;
